import { BaseRequestWithBody } from './baseRequestWithBody';
import * as t from 'io-ts';
import { ApiVersion, Authentication } from 'acscp/api/requests/core/baseRequest';

/**
 * Base class for all PUT requests.
 */
export class BasePutRequest<T> extends BaseRequestWithBody<T> {
    constructor(
        relativeUrl: string,
        queryStringParameters: {[key: string]: string},
        bodyData: any,
        resultDynamicType: t.Type<T>,
        authenticationRequired: Authentication = Authentication.Login,
        apiVersion: ApiVersion = 'v1'
    ) {
        super(relativeUrl, queryStringParameters, bodyData, resultDynamicType,
            'PUT', authenticationRequired, apiVersion);
    }
}
